import { render, staticRenderFns } from "./searchfrom.vue?vue&type=template&id=50c9056a&scoped=true&"
import script from "./searchfrom.vue?vue&type=script&lang=js&"
export * from "./searchfrom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c9056a",
  null
  
)

export default component.exports